const version = "2.7.6";

export { version };
//# sourceMappingURL=version.mjs.map
